(function($){
    'use strict';
    if (typeof $.cookie('fb_cookie_agree') === 'undefined') {
        $('.cookie-policy').show();
    }

    $('.cookie-policy__agree').click(function() {
        $.cookie('fb_cookie_agree', true);
        $('.cookie-policy').fadeOut('fast');
    });
    
}(jQuery));

